// import { createClient } from '@supabase/supabase-js'

// const supabaseUrl = 'https://nenwyzgvqwiuvtnkbubm.supabase.co'
// const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjoiYW5vbiIsImlhdCI6MTYyOTU0NDk3OSwiZXhwIjoxOTQ1MTIwOTc5fQ.RT0Af5IE-Ftcag4t33ZqYBL-MNq0Ha5nPsAVZELSBYQ'

// export const supabase = createClient(supabaseUrl, supabaseAnonKey)

import { createClient } from '@supabase/supabase-js'
import { supabase_url, supabase_anon_key } from '../env';

const supabaseUrl = supabase_url;
const supabaseAnonKey = supabase_anon_key;

export const supabase = createClient(supabaseUrl, supabaseAnonKey)